module.exports = __webpack_public_path__ + "static/media/demo.791b0149.mp4";